<template>
  <ProductContentDetails
    :offer="offer"
    class="delivered-items"
    headline="Lieferumfang"
    :render-item-if="(prod) => prod.deliveredItems?.length > 0"
  >
    <template #default="props">
      <BulletPointList :list="props.product?.deliveredItems || []" />
    </template>
  </ProductContentDetails>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import BulletPointList from '~/components/bullet-point-list.vue';
import ProductContentDetails from '~/components/product-detail/tabs/product-content-details.vue';
import type { Offer } from '~/lib/goliath/offer-by-slugs';

export default defineComponent({
  name: 'DeliveredItems',
  components: {
    BulletPointList,
    ProductContentDetails,
  },
  props: {
    offer: {
      type: Object as PropType<Offer>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
@use 'assets/selectors/pattern/links';

.delivered-items {
  :deep(.list__element) a {
    @extend .link;
  }
}
</style>
